import { ApiProperty } from "@nestjs/swagger";

export class PoStockrequest{
    @ApiProperty()
    itemSubcategoryId:number;
    @ApiProperty()
    saleOrderId?:number;
    @ApiProperty()
    unitId?:number;
    @ApiProperty()
    vendorId?:number;
    @ApiProperty()
    itemId?:number;
    @ApiProperty()
    fromDate?:Date;
    @ApiProperty()
    toDate?:Date;
}